import { useEffect, useMemo } from 'react'
import { Center, Text, HStack, Box, VStack, Link, Image, AspectRatio } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { userHashAtom, userPointsAtom, userCoinsAtom, userUsableCoinsAtom } from '@!/atoms/userInfoAtom'
import { useAppCookies, useCheckPurchasedBooks, usePointCount, useCoinCounts } from '@!/Hooks'
import { isBlank, getDevice, buildUrlString } from '@!/Util'
import { ellipsis } from '@!/Store/Common/util'
import { PrimaryButton } from '@!/components/Button'
import { BuyNowButton } from '@!/Store/Common/components/BookList/Button'

const Colophon = ({ content }) => {
  const device = useMemo(() => getDevice(), [])
  const [userHash, setUserHash] = useAtom(userHashAtom)
  const { userHashCookie, setOpenViewerCookie } = useAppCookies()
  const [, setUserCoins] = useAtom(userCoinsAtom)
  const [userUsableCoins] = useAtom(userUsableCoinsAtom)
  const [userPoints, setUserPoints] = useAtom(userPointsAtom)
  const { data: coins } = useCoinCounts(userHash)
  const { data: points } = usePointCount(userHash)

  useEffect(() => {
    setUserHash(userHashCookie)
    setUserPoints(points)
    setUserCoins(coins)
  }, [userHashCookie, points, coins])

  const { data: purchasedVolumesIds } = useCheckPurchasedBooks(userHash, [content.content_id])

  const purchased = !isBlank(purchasedVolumesIds)

  const handleReadBook = (type) => {
    if (type === 'free' && userHash) {
      window.top.location.href = buildUrlString('/store/purchase', { book_id: content.content_id })
      return
    }

    // 作品詳細へ遷移し、ビューワーを起動
    setOpenViewerCookie(type)
    window.top.location.href = `/store/books/${content.content_id}`
  }

  // タイトルは35文字(3行)以内で表示
  const FRONT_LENGTH = 30
  const END_LENGTH = 5

  return (
    <Center bg="white" w="100%" h="100%" position="absolute" alignItems="flex-end">
      <VStack spacing={4} w={device == 'sp' ? '325px' : '350px'} fontWeight="semibold">
        <HStack spacing={3} w="100%" alignItems="flex-start">
          <AspectRatio ratio={1 / 1.4} w="144px">
            <Image src={content.image_url} alt={content.content_name} />
          </AspectRatio>
          <Box flex={1}>
            <Text fontSize="xl" mb={2}>
              {ellipsis(content.content_name, FRONT_LENGTH, END_LENGTH)}
            </Text>
            <Text fontSize="xs">価格：{content.price}円</Text>
            {userHash && (
              <>
                <Text fontSize="xs">保有ポイント：{userPoints}pt</Text>
                <Text fontSize="xs">保有コイン：{userUsableCoins}コイン</Text>
              </>
            )}
          </Box>
        </HStack>

        {!userHash && content.price > 0 ? (
          <VStack spacing={2} w="100%">
            <PrimaryButton variant="outline" as="a" href="/user/login" target="_top" height={device == 'sp' ? '36px' : '42px'}>
              ログインする
            </PrimaryButton>
            <PrimaryButton as="a" href="/user/login#/registrations" target="_top" height={device == 'sp' ? '36px' : '42px'}>
              新規会員登録（無料）
            </PrimaryButton>
          </VStack>
        ) : (
          <Box w="100%" h={device == 'sp' ? '36px' : '42px'}>
            {purchased ? (
              <PrimaryButton height="100%" onClick={() => handleReadBook('purchased')}>
                続きを読む
              </PrimaryButton>
            ) : content.price === 0 ? (
              <PrimaryButton height="100%" onClick={() => handleReadBook('free')}>
                無料で読む
              </PrimaryButton>
            ) : (
              <BuyNowButton content={content}>購入する</BuyNowButton>
            )}
          </Box>
        )}

        <Link href={`/store/books/${content.content_id}`} target="_top" fontSize="xs">
          作品詳細ページへ
        </Link>
      </VStack>
    </Center>
  )
}

export default Colophon
